export const API_URL =
  process.env.VUE_APP_CPE_API || "https://api.edpl.us/v1/cpe/";
export default API_URL;
